import React from "react";
import { Text, View } from "react-native";
import useAppStore from "../../StateStore/ZustandStore";
import HeadingSection from "./Componets/HeadingSection";
import OneStop from "./Componets/OneStop";
import AiProcumentor from "./Componets/IntelliSales";
import { backgroundLight } from "../../Constants/Colors";
import ServerFree from "./Componets/ServerFree";
import EcosystemIntro from "./Componets/EcosystemIntro";
import WhatYouGain from "./Componets/WhatYouGain";
import Testimonials from "./Componets/Testimonials";

const Home = () => {
  const setModal = useAppStore((state) => state.setModal);

  return (
    <View style={{ backgroundColor: backgroundLight, alignItems: "center", width: "100%" }}>
      <HeadingSection onPressLearnMore={() => setModal("ContactUs")} />
      <ServerFree />
      <EcosystemIntro />
      <OneStop />

      <AiProcumentor />

      <Testimonials />
      <WhatYouGain />
      {/* <View style={{ height: 400 }} /> */}
    </View>
  );
};

export default Home;
